import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { title: '首页' },
    component: Home
  },
  {
    path: '/square',
    name: 'Square',
    meta: { title: '信息广场' },
    component: () => import('../views/Square.vue')
  },
  {
    path: '/publish',
    name: 'Publish',
    meta: { title: '发布' },
    component: () => import('../views/Publish.vue')
  },
  {
    path: '/legal-docs',
    name: 'LegalDocs',
    meta: { title: '代写文书' },
    component: () => import('../views/LegalDocs.vue')
  },
  {
    path: '/faq',
    name: 'Faq',
    meta: { title: '常见问题' },
    component: () => import('../views/Faq.vue')
  },
  {
    path: '/faq-detail',
    name: 'FaqDetail',
    meta: { title: '常见问题详情' },
    component: () => import('../views/FaqDetail.vue')
  },
  {
    path: '/register',
    name: 'Register',
    meta: { title: '注册' },
    component: () => import('../views/Register.vue')
  },
  {
    path: '/login',
    name: 'Login',
    meta: { title: '登录' },
    component: () => import('../views/Login.vue')
  },
  {
    path: '/profile',
    name: 'Profile',
    meta: { title: '个人中心' },
    component: () => import('../views/Profile.vue')
  },
  {
    path: '/my-orders',
    name: 'MyOrders',
    meta: { title: '我的订单' },
    component: () => import('../views/MyOrders.vue')
  },
  {
    path: '/my-claims',
    name: 'MyClaims',
    meta: { title: '我的债权' },
    component: () => import('../views/MyClaims.vue')
  },
  {
    path: '/my-debts',
    name: 'MyDebts',
    meta: { title: '我的债务' },
    component: () => import('../views/MyDebts.vue')
  },
  {
    path: '/my-favorites',
    name: 'MyFavorites',
    meta: { title: '我的收藏' },
    component: () => import('../views/MyFavorites.vue')
  },
  {
    path: '/my-legal-docs',
    name: 'MyLegalDocs',
    meta: { title: '我的代写' },
    component: () => import('../views/MyLegalDocs.vue')
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    meta: { title: '订单详情', noScrollReset: true },
    component: () => import('../views/OrderDetail.vue')
  },
  {
    path: '/my-claim-detail',
    name: 'MyClaimDetail',
    meta: { title: '债权详情', noScrollReset: true },
    component: () => import('../views/MyClaimDetail.vue')
  },
  {
    path: '/my-debt-detail',
    name: 'MyDebtDetail',
    meta: { title: '债务详情', noScrollReset: true },
    component: () => import('../views/MyDebtDetail.vue')
  },
  {
    path: '/detail',
    name: 'Detail',
    meta: { title: '详情', noScrollReset: true },
    component: () => import('../views/Detail.vue')
  },
  {
    path: '/edit-page',
    name: 'EditPage',
    meta: { title: '编辑信息' },
    component: () => import('../views/EditPage.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: { title: '关于我们' },
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    meta: { title: '联系我们' },
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/customer-service',
    name: 'CustomerService',
    meta: { title: '客服中心' },
    component: () => import('../views/CustomerService.vue')
  },
  {
    path: '/agreement',
    name: 'Agreement',
    meta: { title: '平台服务协议' },
    component: () => import('../views/Agreement.vue')
  },
  {
    path: '/search-list',
    name: 'SearchList',
    meta: { title: '搜索结果' },
    component: () => import('../views/SearchList.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 浏览器前进/后退时，恢复之前保存的位置
    if (savedPosition) {
      return savedPosition
    }
    // 从标记了 noScrollReset 的页面离开时，保留滚动位置（如从详情返回列表）
    if (from.meta && from.meta.noScrollReset) {
      return false
    }
    // 默认回到顶部
    return { x: 0, y: 0 }
  }
})

// 全局前置守卫：切换页面时修改标题
router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title ? `${to.meta.title} - 神通债权` : '神通债权'
  document.title = title
  next()
})

export default router
